import "core-js/modules/es6.object.freeze.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.string.link.js";
import "core-js/modules/es6.function.name.js";
import _first from "lodash/first";
import _get from "lodash/get";
import _last from "lodash/last";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  fragment getAboutSchema on PostInterface {\n    __typename\n    ... on Article {\n      categories {\n        name\n      }\n    }\n    ... on Roundup {\n      categories {\n        name\n      }\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  fragment getEditorSchema on Article {\n    __typename\n    assigningEditor {\n      id\n      name\n      link\n      avatarUrls(sizes: [SIZE_96]) {\n        size\n        url\n      }\n      alumniOf\n      affiliation\n      award\n      honorificSuffix\n      jobTitle\n      specialties\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  fragment getAuthorSchema on PostWithAuthorsInterface {\n    __typename\n    authors {\n      id\n      name\n      link\n      avatarUrls {\n        size\n        url\n      }\n      alumniOf\n      affiliation\n      award\n      honorificSuffix\n      jobTitle\n      specialties\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fragment getUserInfoSchema on PostInterface {\n    id\n    link\n    ... on PostWithContactInfoInterface {\n      socialMediaLinks {\n        type\n        url\n      }\n    }\n    ... on ContentUserPage {\n      awards\n      name: fullName\n      jobTitle\n      featuredMedia {\n        id\n        croppedImage {\n          sourceUrl\n        }\n      }\n      credentials\n      memberOf: organizations\n      user {\n        knowsAbout: specialties\n        alumniOf\n        description\n        affiliation\n      }\n    }\n    ... on ContentReviewer {\n      name: fullName\n      honorificSuffix\n      jobTitle\n      knowsAbout: experience\n      alumniOf\n      description\n      featuredMedia {\n        id\n        croppedImage {\n          sourceUrl\n        }\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment getReviewerSchema on PostWithReviewerInterface {\n    __typename\n    reviewedBy {\n      id\n      name\n      link\n      honorificSuffix\n      jobTitle\n      knowsAbout\n      alumniOf\n      featuredMedia {\n        id\n        croppedImages(sizes: [SQUARE_350, SQUARE_160, SQUARE]) {\n          sourceUrl\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { gql } from '@nerdwallet/apollo';
import { getAuthors, getReviewers } from '@nerdwallet/wp-api/selectors/common';
import { NERDWALLET_AUTHOR_ID, ORGANIZATION } from '../../constants';
/*
 * Get the schema for ContentReviewer
 *
 * @param  {Object} post WordPress post object
 *
 * @return {Object} ContentReviewer schema
 */

export var getReviewerSchema = function getReviewerSchema(post) {
  // eslint-disable-next-line no-underscore-dangle, no-use-before-define
  if (post.__typename) return getReviewerSchemaGql(post);
  var reviewers = getReviewers(post);
  var primaryReviewer = reviewers[0]; // only include the primary reviewer

  if (!primaryReviewer) return undefined;
  var reviewerSchema = {
    '@type': 'Person',
    name: primaryReviewer.nw_data.name,
    sameAs: primaryReviewer.link,
    honorificSuffix: primaryReviewer.nw_data.honorific_suffix,
    jobTitle: primaryReviewer.nw_data.job_title,
    knowsAbout: primaryReviewer.nw_data.knows_about
  };

  if (primaryReviewer.nw_data.alumni_of) {
    reviewerSchema.alumniOf = {
      '@type': 'EducationalOrganization',
      name: _last(primaryReviewer.nw_data.alumni_of)
    };
  }

  return reviewerSchema;
};
getReviewerSchema.fragment = gql(_templateObject());
/*
 * Get the schema for UserInfo
 *
 * @param  {Object} UserInfoInterface object
 *
 * @return {Object} Person schema
 */

export var getUserInfoSchema = function getUserInfoSchema(userInfo) {
  // eslint-disable-next-line no-use-before-define
  return getPersonSchemaGql(userInfo);
};
getUserInfoSchema.fragment = gql(_templateObject2());
/*
 * Get the schema for Author
 *
 * @param  {Object} post WordPress post object
 *
 * @return {Object} Author schema
 */

export var getAuthorSchema = function getAuthorSchema(post) {
  // eslint-disable-next-line no-underscore-dangle, no-use-before-define
  if (post.__typename) return getAuthorSchemaGql(post);
  var authorSchema = {};
  var authors = getAuthors(post);
  var primaryAuthor = authors[0]; // only include the primary author

  if (primaryAuthor) {
    if (primaryAuthor.id === NERDWALLET_AUTHOR_ID) {
      // NerdWallet
      authorSchema = {
        '@id': ORGANIZATION['@id']
      };
    } else {
      authorSchema = {
        '@type': 'Person',
        image: _get(primaryAuthor, 'avatar_urls[96]'),
        name: primaryAuthor.name,
        sameAs: primaryAuthor.link,
        award: primaryAuthor.nw_user_award,
        honorificSuffix: primaryAuthor.nw_user_honorific_suffix,
        jobTitle: primaryAuthor.nw_user_job_title,
        knowsAbout: primaryAuthor.nw_user_specialties
      };

      if (primaryAuthor.nw_user_affiliation) {
        authorSchema.affiliation = {
          '@type': 'Organization',
          name: primaryAuthor.nw_user_affiliation
        };
      }

      if (primaryAuthor.nw_user_alumni_of) {
        authorSchema.alumniOf = {
          '@type': 'EducationalOrganization',
          name: primaryAuthor.nw_user_alumni_of
        };
      }
    }
  }

  return authorSchema;
};
getAuthorSchema.fragment = gql(_templateObject3());
/*
 * Get the schema for a Person
 *
 * @param  {Object} person query0 person object
 *
 * @return {Object} Person schema
 */

var getPersonSchemaGql = function getPersonSchemaGql(person) {
  var _ref, _last$url, _last2, _first2, _person$featuredMedia, _person$featuredMedia2, _person$featuredMedia3, _person$user$descript, _person$user, _person$awards, _person$socialMediaLi, _person$credentials, _person$user2, _person$user2$alumniO, _person$alumniOf, _person$memberOf, _person$knowsAbout;

  var personSchema = {};

  if (!person) {
    return personSchema;
  }

  if (person.id === NERDWALLET_AUTHOR_ID) {
    // NerdWallet
    return {
      '@id': ORGANIZATION['@id']
    };
  }

  personSchema = {
    '@type': 'Person',
    image: (_ref = (_last$url = (_last2 = _last(person.avatarUrls)) === null || _last2 === void 0 ? void 0 : _last2.url) !== null && _last$url !== void 0 ? _last$url : (_first2 = _first((_person$featuredMedia = person.featuredMedia) === null || _person$featuredMedia === void 0 ? void 0 : _person$featuredMedia.croppedImages)) === null || _first2 === void 0 ? void 0 : _first2.sourceUrl) !== null && _ref !== void 0 ? _ref : (_person$featuredMedia2 = person.featuredMedia) === null || _person$featuredMedia2 === void 0 ? void 0 : (_person$featuredMedia3 = _person$featuredMedia2.croppedImage) === null || _person$featuredMedia3 === void 0 ? void 0 : _person$featuredMedia3.sourceUrl,
    name: person.name,
    honorificSuffix: person.honorificSuffix,
    jobTitle: person.jobTitle,
    url: person.link,
    description: (_person$user$descript = (_person$user = person.user) === null || _person$user === void 0 ? void 0 : _person$user.description) !== null && _person$user$descript !== void 0 ? _person$user$descript : person.description
  };

  if (((_person$awards = person.awards) === null || _person$awards === void 0 ? void 0 : _person$awards.length) > 0) {
    personSchema.award = person.awards;
  } else if (person.award) {
    personSchema.award = person.award;
  }

  if (person.affiliation) {
    personSchema.affiliation = {
      '@type': 'Organization',
      name: person.affiliation
    };
  }

  if (((_person$socialMediaLi = person.socialMediaLinks) === null || _person$socialMediaLi === void 0 ? void 0 : _person$socialMediaLi.length) > 0) {
    personSchema.sameAs = person.socialMediaLinks.map(function (mediaLink) {
      return mediaLink.url;
    });
  }

  if (((_person$credentials = person.credentials) === null || _person$credentials === void 0 ? void 0 : _person$credentials.length) > 0) {
    personSchema.hasCredential = person.credentials.map(function (credential) {
      return {
        '@type': 'EducationalOccupationalCredential',
        name: credential
      };
    });
  }

  if (((_person$user2 = person.user) === null || _person$user2 === void 0 ? void 0 : (_person$user2$alumniO = _person$user2.alumniOf) === null || _person$user2$alumniO === void 0 ? void 0 : _person$user2$alumniO.length) > 0 || Array.isArray(person.alumniOf) && ((_person$alumniOf = person.alumniOf) === null || _person$alumniOf === void 0 ? void 0 : _person$alumniOf.length) > 0) {
    var _person$user$alumniOf, _person$user3;

    personSchema.alumniOf = {
      '@type': 'EducationalOrganization',
      name: (_person$user$alumniOf = (_person$user3 = person.user) === null || _person$user3 === void 0 ? void 0 : _person$user3.alumniOf) !== null && _person$user$alumniOf !== void 0 ? _person$user$alumniOf : person.alumniOf
    };
  } else if (person.alumniOf && !Array.isArray(person.alumniOf)) {
    personSchema.alumniOf = {
      '@type': 'EducationalOrganization',
      name: person.alumniOf
    };
  }

  if (((_person$memberOf = person.memberOf) === null || _person$memberOf === void 0 ? void 0 : _person$memberOf.length) > 0) {
    personSchema.memberOf = person.memberOf.map(function (memberOf) {
      return {
        '@type': 'Organization',
        name: memberOf
      };
    });
  }

  if (((_person$knowsAbout = person.knowsAbout) === null || _person$knowsAbout === void 0 ? void 0 : _person$knowsAbout.length) > 0) {
    personSchema.knowsAbout = person.knowsAbout.split(';').map(function (knowsAbout) {
      return knowsAbout.trim();
    });
  }

  if (person.user) {
    // currently having a user object means the person is an author.
    personSchema.publishingPrinciples = 'https://www.nerdwallet.com/l/editorial-guidelines';
  }

  return personSchema;
};
/*
 * Get the schema for Author
 *
 * @param  {Object} post query0 post object
 *
 * @return {Object} Author schema
 */


var getAuthorSchemaGql = function getAuthorSchemaGql(post) {
  var _post$authors;

  var authors = (_post$authors = post === null || post === void 0 ? void 0 : post.authors) !== null && _post$authors !== void 0 ? _post$authors : [];
  var primaryAuthor = authors[0]; // only include the primary author

  return getPersonSchemaGql(primaryAuthor);
};
/*
 * Get the schema for ContentReviewer
 *
 * @param  {Object} post query0 post object
 *
 * @return {Object} ContentReviewer schema
 */


var getReviewerSchemaGql = function getReviewerSchemaGql(post) {
  var _post$reviewedBy;

  var reviewers = (_post$reviewedBy = post === null || post === void 0 ? void 0 : post.reviewedBy) !== null && _post$reviewedBy !== void 0 ? _post$reviewedBy : [];
  var primaryReviewer = reviewers[0];
  return getPersonSchemaGql(primaryReviewer);
};
/*
 * Get the schema for Editor
 *
 * @param  {Object} post query0 post object
 *
 * @return {Object} Editor schema
 */


export var getEditorSchema = function getEditorSchema(post) {
  var editor = post === null || post === void 0 ? void 0 : post.assigningEditor;
  return getPersonSchemaGql(editor);
};
getEditorSchema.fragment = gql(_templateObject4());
/**
 * Get about schema for categories
 *
 * @param  {Array} categories array
 *
 * @return {Array} categories with mapped schema array
 */

export var getAboutSchema = function getAboutSchema(categories) {
  // eslint-disable-next-line no-use-before-define, no-underscore-dangle
  if (categories.__typename) return getAboutSchemaGql(categories);
  return categories.map(function (category) {
    return {
      '@type': 'Thing',
      name: _get(category, 'name')
    };
  });
};
getAboutSchema.fragment = gql(_templateObject5());
/**
 * Get about schema for categories
 *
 * @param  {Object} post query0 object
 *
 * @return {Array} categories with mapped schema array
 */

var getAboutSchemaGql = function getAboutSchemaGql(post) {
  var _post$categories;

  return ((_post$categories = post === null || post === void 0 ? void 0 : post.categories) !== null && _post$categories !== void 0 ? _post$categories : []).map(function (category) {
    return {
      '@type': 'Thing',
      name: category === null || category === void 0 ? void 0 : category.name
    };
  });
};